import React from "react";
import Countries from "./../components/Countries"

const Home = () => {
    return (
        <div>
            <h1>Accueil</h1>
            <Countries />
        </div>
    );
};

export default Home;
